import i18next from "../../../i18n";
import MaterialOfferItem from "../../MaterialOfferItem/MaterialOfferItem";
import { MaterialCompaniesPaginatedOpportunitiesResponse } from "../../../types";

type PotencialSuppliersProps = {
  setOpen: (value: boolean) => void;
  setPotencialSupplierToShow: (value: any) => void;
  materialCompaniesOpportunities: MaterialCompaniesPaginatedOpportunitiesResponse;
};

const PotencialSuppliers = ({
  setOpen,
  setPotencialSupplierToShow,
  materialCompaniesOpportunities,
}: PotencialSuppliersProps) => {
  return (
    <div>
      {!materialCompaniesOpportunities?.content?.length ? (
        <p className="material-suppliers__empty">
          {i18next.t("material.noPotencialSuppliers")}
        </p>
      ) : (
        <ul className="material-suppliers__list">
          {materialCompaniesOpportunities?.content?.map((item) => (
            <MaterialOfferItem
              key={item.user.id}
              potencialSupplier={item}
              handleItemClick={() => {
                setOpen(true);
                setPotencialSupplierToShow(item);
              }}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default PotencialSuppliers;
